<script setup>
import { Icon } from '@iconify/vue';

const props = defineProps({
    modelValue: {
        type: [Number, String],
        required: true
    },
    tabs: {
        type: Array,
        required: true
    }
});

const emit = defineEmits(['update:modelValue', 'change']);

const selectTab = (tab) => {
    emit('update:modelValue', tab.id);
    emit('change', tab);
};
</script>

<template>
    <div class="flex overflow-x-auto gap-2 bg-slate-100/80 dark:bg-slate-800/80 p-1.5 rounded-2xl w-max max-w-full custom-scrollbar border border-slate-200 dark:border-slate-700">
        <template v-for="tab in tabs" :key="tab.id">
            <button 
                v-if="tab.show !== false"
                @click="selectTab(tab)" 
                class="tab-btn-premium" 
                :class="modelValue === tab.id ? 'tab-btn-premium-active' : 'tab-btn-premium-inactive'"
            >
                <span class="flex items-center gap-2">
                    <Icon v-if="tab.icon" :icon="tab.icon" class="w-4 h-4" />
                    {{ tab.label }}
                </span>
            </button>
        </template>
    </div>
</template>
